import {Injectable} from '@angular/core';
import {Role} from '@user/role.model';
import { environment } from '@environments/environment';
import { BaseRestApiService } from '@shared/services/base-rest-api.service';
import { RestApiWrapperService } from '@shared/services/rest-api-wrapper.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoleAdminService extends BaseRestApiService {
  public roleUri = environment.serverUri + `api/${environment.apiVersion}/roles`;

  constructor(_restApiWrapperService: RestApiWrapperService) {
    super(_restApiWrapperService);
  }

  public list(): Observable<Role[]> {
    return this.get<Role[]>(this.roleUri, {params: {page: 0, size: 1000}});
  }
}
